export const FLAG_GETTING_DELIVERY_LOCATION_DISTRICTS = 'FLAG_GETTING_DELIVERY_LOCATION_DISTRICTS';
export const GET_DELIVERY_LOCATION_DISTRICTS = 'GET_DELIVERY_LOCATION_DISTRICTS';
export const CLEAR_DELIVERY_LOCATION_DISTRICTS = 'CLEAR_DELIVERY_LOCATION_DISTRICTS';
export const FLAG_DELIVERY_LOCATION_DISTRICT_ACTIVITY = 'FLAG_DELIVERY_LOCATION_DISTRICT_ACTIVITY';
export const GET_DELIVERY_LOCATION_DISTRICT = 'GET_DELIVERY_LOCATION_DISTRICT';
export const CLEAR_DELIVERY_LOCATION_DISTRICT = 'CLEAR_DELIVERY_LOCATION_DISTRICT';
